'use client'
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Projects from "./services/page";
import TopPage from "./components/Top";
import Contact from "./components/Contact";
import StructuredData from "./components/StructuredData";



export default function Home() {
  return (
    <>
     <StructuredData />
     
      <Navbar />
      <TopPage />
      <Projects />
      <Contact />
      <Footer />
    </>
  )
}

